var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import styled from "../themes/styled";
import Box from "../box/Box";
import { theme, prop } from "styled-tools";
import { useInView } from "react-intersection-observer";
var lazyOptions = {
    triggerOnce: true,
    rootMargin: "300px 0px",
};
var Container = styled(Box)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    background-repeat: no-repeat;\n    background-size: auto 70%;\n    background-position: center top;\n\n    @media ", " {\n        background-size: ", ";\n        background-position: ", ";\n        > div {\n            max-width: ", "px;\n            margin: auto;\n            display: grid;\n            grid-template-columns: repeat(12, 1fr);\n        }\n    }\n"], ["\n    background-repeat: no-repeat;\n    background-size: auto 70%;\n    background-position: center top;\n\n    @media ", " {\n        background-size: ", ";\n        background-position: ", ";\n        > div {\n            max-width: ", "px;\n            margin: auto;\n            display: grid;\n            grid-template-columns: repeat(12, 1fr);\n        }\n    }\n"])), theme("mediaQueries.md"), prop("backgroundSize", "cover"), prop("backgroundPosition", "center"), theme("gridMaxWidth"));
export default (function (_a) {
    var backgroundImage = _a.backgroundImage, headline = _a.headline, content = _a.content, _b = _a.contentBgColor, contentBgColor = _b === void 0 ? "white" : _b, rest = __rest(_a, ["backgroundImage", "headline", "content", "contentBgColor"]);
    var _c = useInView(lazyOptions), ref = _c[0], inView = _c[1];
    var srcUrls = undefined;
    if (inView && backgroundImage) {
        srcUrls = Array.isArray(backgroundImage)
            ? backgroundImage.map(function (url) { return "url(\"".concat(url, "\")"); })
            : "url(\"".concat(backgroundImage, "\")");
    }
    return (React.createElement(Container, __assign({ ref: ref, pb: 7, pt: [12, 7], px: 5, backgroundImage: srcUrls }, rest),
        React.createElement("div", null,
            React.createElement(Box, { my: [4, 7], p: [2, 2, 2, 5], gridColumn: "2 / span 10" }, headline),
            React.createElement(Box, { my: [0, 0, 7], mx: 3, p: [5, 5, 5, 8], bg: contentBgColor, gridColumn: "4 / span 8" }, content))));
});
var templateObject_1;
//# sourceMappingURL=MediaBg02.js.map